import React from "react";
import { ConnectedProps, connect } from "react-redux";
import "./index.css";
import { ReducerState } from "../../types";
import CatalogFilters from "../../components/CatalogFilters";
import Catalog from "../../components/Catalog";

const mapStateToProps = (state: ReducerState) => {
  return {
    selected: state.devices?.selected?.uuid || null,
  };
};

const connector = connect(mapStateToProps, {});

type Props = ConnectedProps<typeof connector> & {
  // Extra props go here
};

const ImageCatalog: React.FC<Props> = () => {
  return (
    <div className="mx-6 flex min-h-full pt-8 h-fit">
      <div className="max-w-100 h-full w-74">
        <CatalogFilters />
      </div>
      <div className="flex-1 ml-6">
        <Catalog />
      </div>
    </div>
  );
};

export default connector(ImageCatalog);
